import Footer from "../../../../Components/Footer/Footer";
import { Button, Form, Card } from "react-bootstrap";
import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import { toast } from 'react-hot-toast';
import Loading from 'react-fullscreen-loading';
import AuthLeftPanel from "../../../User/Auth/LeftAuthPanel/AuthLeftPanel";
import '../Signin/Signin.css';
import logo from '../../../../assets/Logo/cadomationnewlogo.webp';
import TurnstileCaptcha from '../../../../Components/Captcha/TurnstileCaptcha';

export default function ForgotPasswordRequest(){
    const navigate = useNavigate();
    const [screenloader,setScreenloader] = useState(false);
    const [email,setEmail] = useState("");
    const [recaptchaToken, setRecaptchaToken] = useState(null);
    const [captchaLoaded, setCaptchaLoaded] = useState(false);
    const captchaRef = useRef(null);
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => { const checkScreen = () => setIsMobile(window.innerWidth <= 600); 
        checkScreen(); window.addEventListener("resize", checkScreen); 
        return () => window.removeEventListener("resize", checkScreen); }, []);

    const ResetPasswordRequest=async()=>{
        await axios.post(`${process.env.REACT_APP_API_URL}/auth/forgotpasswordrequest`,{
            email:email,
            recaptchaToken: recaptchaToken,
        })
        .then(res=>{
            setScreenloader(false);
            if(res.data && res.data.status !== undefined){
                if(res.data.status===1){
                    toast.success("Verification Code sent to your email!");
                    navigate(`/ChangePassword/${email}`, { replace: true });
                    return;
                }else{
                    toast.error(res.data.message);
                    resetCaptcha();
                    return;
                }
            }
        })
        .catch(er=>{
            setScreenloader(false);
            if(er.response.data?.message){
                toast.error(er.response.data?.message);
                resetCaptcha();
                return;
            }else{
                console.log(er)
                toast.error("Unable to connect to Server");
                resetCaptcha();
                return;
            }
        })
    }
    const SubmitResetRequest=async(e)=>{
        e.preventDefault();
        if (!captchaLoaded) {
            toast.error("Captcha is not loaded yet. Please wait.");
            return;
        }
        if (!recaptchaToken) {
            toast.error("Please verify you're not a robot.");
            return;
        }
        setScreenloader(true);
        await ResetPasswordRequest();
    }
    const resetCaptcha = () => {
        if (captchaRef.current && typeof captchaRef.current.reset === 'function') {
            captchaRef.current.reset();
        }
        setRecaptchaToken(null);
    }
    return (
        <>
            <Loading loading={screenloader} background="#fff" loaderColor="#883484" />
            <div className="signin-page">
                <div className="auth-wrapper">
                        <AuthLeftPanel />
                    <div className="right-panel">
                        <Card className="signin-card compact-card"> <Card.Body>
                            <div className="logo-wrapper text-center mb-4">
                                <div>
                                <img src={logo} alt="Cadomation" className="signin-logo" />
                                </div>
                                <p className="form-title">Forgot Password</p>
                                <p className="form-sub">
                                    Enter your registered email address, and we'll send you a verification code to reset your password. The code will expire after 10 minutes for security reasons.  
                                </p>
                                <p className="helper-text">  
                                    💡 Didn't get the email? Please check your Spam/Junk folder or contact our support team for help.
                                </p>
                            </div>
                            <Form onSubmit={SubmitResetRequest} style={{ width: "100%" }}>
                                <Form.Group className="mb-4" controlId="email">
                                    <Form.Control
                                        type="email"
                                        className="form-input"
                                        placeholder="e.g username@gmail.com"
                                        required
                                        value={email}
                                        onChange={e => setEmail(e.target.value)}
                                    />
                                </Form.Group>

                                <TurnstileCaptcha
                                    ref={captchaRef}
                                    onVerify={setRecaptchaToken}
                                    onExpire={() => setRecaptchaToken(null)}
                                    onLoad={() => setCaptchaLoaded(true)}
                                />

                                <Button
                                    variant="primary"
                                    type="submit"
                                    className="btn-signin w-100 mb-3"
                                >
                                    Send Verification Code
                                </Button>

                                <Button
                                    variant="outline-secondary"
                                    type="button"
                                    className="w-100"
                                    onClick={() => navigate("/Signin")}
                                >
                                    ← Return to Sign In
                                </Button>
                                
                            </Form>
                            </Card.Body> {isMobile && <Footer />} </Card>
                        </div>
                    </div>
            {!isMobile && <Footer />}
                </div>
        </>
    );
}
